import React from 'react';

import { useOverlayState } from '../../../../hooks/useOverlayState';

import Checkbox from '../../../../design-system/Checkbox/Checkbox';
import ProvideInformationModal from '../ProvideInformationModal/ProvideInformationModal';
import { SvgIcon } from '../../../../design-system';
import { InformationLineIcon } from '../../../../design-system/Icons';

const RequirementContentItem = ({ item, setContentItem, isEditable }) => {
    const { name, label, is_included, info_required, question, answer } = item;

    const { isOpened, open: openModal, close: closeModal } = useOverlayState();

    const onCheckboxChange = (e) => {
        setContentItem((prevItem) => ({
            ...prevItem,
            is_included: e.target.checked,
        }));
    };

    return (
        <div className="flex items-center gap-2 justify-between p-1.5 border-b-1 border-neutral-100">
            <div className="flex items-center gap-2">
                <Checkbox
                    isChecked={is_included}
                    name={name}
                    onChange={onCheckboxChange}
                    state={isEditable ? 'default' : 'disabled'}
                />
                <p className="font-body text-body-regular-xs text-neutral-500">{label}</p>
            </div>

            {isEditable && (
                <>
                    {info_required && !answer && (
                        <InfoButton
                            color="#E95B69"
                            text="Needs information, click here to add"
                            onClick={openModal}
                        />
                    )}

                    {info_required && !!answer && (
                        <InfoButton
                            color="#AEB758"
                            text="Information added, click here to view"
                            onClick={openModal}
                        />
                    )}
                </>
            )}

            {isOpened && (
                <ProvideInformationModal
                    label={label}
                    question={question}
                    answer={answer}
                    setContentItem={setContentItem}
                    onClose={closeModal}
                />
            )}
        </div>
    );
};

function InfoButton({ text, color, onClick }) {
    return (
        <button className="flex gap-1 flex-nowrap" onClick={onClick}>
            <SvgIcon color={color} icon={InformationLineIcon} size="medium" />

            <p
                style={{ color }}
                className="font-body text-body-regular-xs underline underline-offset-2 whitespace-nowrap"
            >
                {text}
            </p>
        </button>
    );
}

export default RequirementContentItem;
